import API from "@/global/request/api";
import axios from "@/global/request/axios";

export default {
  coursewareList(params) {
    return axios.get(API.courseware, params);
  },
  coursewareDetail(id) {
    return axios.get(API.coursewareId(id));
  },
  coursewareRecommend(params) {
    return axios.get(API.coursewareRecommends, params);
  },
  coursewareIdSub(id) {
    return axios.put(API.coursewareIdSub(id));
  },
  coursewareIdCancelSub(id) {
    return axios.put(API.coursewareIdCancelSub(id));
  },
  coursewareDownload(id) {
    return axios.put(API.coursewareDownload(id));
  }
};
